import {
  Tooltip as MuiTooltip, tooltipClasses, TooltipProps
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import {
  PRODUCT_TOOLTIP_BACKGROUND_OPACITY,
  PRODUCT_TOOLTIP_MAX_WIDTH
} from "../../utils/constants";

/**
 * A custom tooltip component based on the Mui Tooltip component.
 * This will apply a maximum size restriction, centers its contained text, changes its background opacity and the font size of the tooltip.
 * 
 * @param {string} className string to reference the tooltip object within the DOM.
 * @param {TooltipProps} props the remaining props object that is defined by Mui.
 */
const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip
      {...props}
      classes={{
          popper: className
      }}
  />
  ))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: PRODUCT_TOOLTIP_MAX_WIDTH,
    opacity: PRODUCT_TOOLTIP_BACKGROUND_OPACITY,
    padding: 0,
    textAlign: "center",
    boxShadow: "0px 0px 135px -19px rgba(0,0,0,0.75)",
    backgroundColor: "rgb(91, 91, 91) !important",
    borderRadius: "12px !important",
    overflow: "hidden !important", 
  },
  [`& .${tooltipClasses.popper}`]: {
    maxWidth: PRODUCT_TOOLTIP_MAX_WIDTH,
    opacity: PRODUCT_TOOLTIP_BACKGROUND_OPACITY,
    textAlign: "center"
  },
});

export default Tooltip;